import Loader from '@/components/Loader'
import { Menu, Transition, Switch, Popover } from '@headlessui/react'
import { BanIcon, ChevronDownIcon, ChevronRightIcon, DotsVerticalIcon, MinusIcon, NewspaperIcon, XIcon } from '@heroicons/react/solid'
import { useContext, Fragment, useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import { LayoutContext } from '../contexts/LayoutContext'
import { AuthContext } from '../contexts/AuthContext'
import Button from '@/components/Button';
import modalRoutes from '@/modalRoutes';
import ChatTransition from '@/transitions/chat.transition';
import { useFirebase, useFirestore, useFirestoreConnect } from "react-redux-firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import errorToast from '../utils/errorToast';
import { CgColorPicker } from "react-icons/cg";
import { SketchPicker } from 'react-color';
import { useOnClickOutside } from '../hooks/useClickOutside';

export default function Chat() {
  const firestore = useFirestore()
  const { chat, toggleChat } = useContext(LayoutContext);
  const { auth, user, chatHistory, } = useContext(AuthContext);
  const [messagesLoaded, setMessagesLoaded] = useState(false)
  const [initialHistory, setInitialHistory] = useState([])
  const [messages, setMessages] = useState([])
  const messageRef = useRef();

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView(
        {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest'
        })
    }
  }, [messages, initialHistory])

  useEffect(() => {
    firestore.collection("messages").where("timestamp", ">=", firestore.Timestamp.fromDate((new Date(new Date().setHours(new Date().getHours() - 4))))).orderBy("timestamp", "asc")
      .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach(change => {
          if (change.type == "added") {
            setMessages(prevState => ([...prevState, { id: change.doc.id, ...change.doc.data() }]))
          }
          if (change.type == "modified") {
            setMessages((prevState) =>
              prevState.map((msg) => {
                return msg.id === change.doc.id ? { id: change.doc.id, ...change.doc.data() } : msg;
              }),
            );
          }
        })
      });
      setMessagesLoaded(true)
  }, [])

  // useEffect(() => {
  //   firestore.collection("messages").where("timestamp", "<", firestore.Timestamp.fromDate(new Date)).orderBy("timestamp", "desc").limit(40)
  //     .onSnapshot((snapshot) => {
  //       snapshot.docChanges().forEach(change => {
  //         if (change.type == "added") {
  //           setInitialHistory(prevState => ([...prevState, { id: change.doc.id, ...change.doc.data() }]))
  //         }
  //         if (change.type == "modified") {
  //           setInitialHistory((prevState) =>
  //             prevState.map((msg) => {
  //               return msg.id === change.doc.id ? { id: change.doc.id, ...change.doc.data() } : msg;
  //             }),
  //           );
  //         }
  //       })
  //     });
  //   setMessagesLoaded(true)
  // }, [])

  // useEffect(() => {
  //   if (Object.values(initialHistory).length > 0) return null
  //   if (chatHistory && Object.values(chatHistory).length > 0) {
  //     let arr = []
  //     for (const [key, value] of Object.entries(chatHistory)) {
  //       arr.push({ id: key, ...value })
  //     }
  //     setInitialHistory(arr)
  //     setMessagesLoaded(true)
  //   }
  // }, [chatHistory])

  const MessageComponent = () => {
    if (user?.banned) {
      return <BannedUser />
    }
    if (auth?.uid) {
      if (user?.username) {
        if (auth?.emailVerified) {
          return <ChatMessage />
        } else {
          return <VerifyEmail />
        }
      } else {
        return <SetUsername />
      }
    } else {
      return <RegisterUser />
    }
  }

  return (
    <Transition as={'div'} show={chat}>
      <Transition.Child
        as={Fragment}
        {...ChatTransition.Main}
      >
        <aside className="flex flex-col w-full lg:w-96 bg-gray-900 fixed h-screenMinusHeader inset-x-0 bottom-0 lg:relative z-50">
          <div className="absolute h-64 bg-gradient-to-b top-0 z-10 from-gray-900 inset-x-0"></div>
          <div className="py-4 border-b border-gray-800 flex items-center justify-between px-4 relative z-10">
            <span className="font-medium ml-4">Chat</span>
            <button className="absolute left-0 transform translate-x-[-50%] text-gray-300 hover:text-gray-100 p-1.5 rounded-full border-gray-800 border bg-gray-900" onClick={toggleChat}>
              <span><ChevronRightIcon className="h-5 w-5" /></span>
            </button>
          </div>
          <div className="flex-1 overflow-auto px-4 relative border-b border-gray-800">
            <Transition.Child
              afterEnter={() => messageRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })}
              as={'div'}
              {...ChatTransition.Children}
              className={!messagesLoaded ? 'h-full flex items-center justify-center' : undefined}
            >
              {!messagesLoaded ? (
                <Loader size="small" />
              ) : (
                <div className="py-4 flex space-y-2 flex-col items-start relative">
                  {/* {initialHistory.filter(msg => !msg.removed).map((message, index) => <ChatMessageItem key={index} message={message} removed={message.removed} />)}
                  <div className="flex items-center w-full text-xs">
                    <div className="flex-1 border-t border-gray-800"></div>
                    <span className="text-gray-300 mx-2 uppercase tracking-wide">today</span>
                    <div className="flex-1 border-t border-gray-800"></div>
                  </div> */}
                  {messages.map((message, index) => <ChatMessageItem key={index} message={message} removed={message.removed} />)}
                  <div className="absolute bottom-0" ref={messageRef}></div>
                  {/* <AlwaysScrollToBottom /> */}
                </div>
              )}
            </Transition.Child>
          </div>
          {/* {user?.banned ? (
            <BannedUser />
          ) : (
            auth?.uid ? (
              user?.username ? (
                <ChatMessage />
              ) : (
                <SetUsername />
              )
            ) : (
              <RegisterUser />
            )
          )} */}
          <MessageComponent />
        </aside>
      </Transition.Child>
    </Transition>
  )
}

const ChatMessage = () => {
  const { auth, userRef, user } = useContext(AuthContext);
  const [message, setMessage] = useState('');
  const characterLimit = 160;
  const firestore = useFirestore();
  const functions = getFunctions();
  const updateUserColor = httpsCallable(functions, 'updateUserColor');
  const ref = useRef();
  const [isOpen, setIsOpen] = useState(false)
  const [color, setColor] = useState(user?.color || "#fff")
  const [isSubmitting, setIsSubmitting] = useState(false)

  useOnClickOutside(ref, async () => {
    setIsOpen(false)
    try {
      await updateUserColor({ color })
    } catch (error) {
      errorToast(error)
    }
  });

  const handleInput = e => {
    if (message.length >= characterLimit) return null
    setMessage(e.target.value)
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (message.length == 0) return
    if (user.banned) {
      errorToast({ message: 'You have been banned from the chat.' })
      return null
    }
    sendData();
  }

  const sendData = async () => {
    const chatRef = firestore.collection("messages");
    try {
      setIsSubmitting(true)
      if (!auth?.emailVerified) {
        throw new Error('Email Verification Required.')
      }
      await chatRef.add({
        sender: userRef,
        username: user.username,
        avatar: user?.avatarUrl,
        color: user?.color,
        message: message,
        timestamp: firestore.Timestamp.fromDate(new Date())
      });
      setMessage("");
    } catch (err) {
      errorToast(err)
    }
    setIsSubmitting(false)
  };

  return (
    <form onSubmit={handleSubmit} className="bg-gray-900 p-4 z-50">
      <div className="flex w-full p-1 bg-gray-800 text-white font-medium text-sm rounded-full focus:outline-none focus:shadow-none focus:ring-0 transition duration-300">
        <input value={message} onChange={handleInput} className="px-4 py-2.5 bg-transparent border-none p-0 placeholder-gray-300" type="text" placeholder="Type your message" />
        <Button disabled={isSubmitting} rounded="rounded-full" modifier="secondary" type="submit" className="px-6 py-2">Send</Button>
      </div>
      <button type="button" onClick={() => setIsOpen(true)} className="flex mt-3 items-center p-1">
        <CgColorPicker className="h-5 w-5 text-gray-300 hover:text-gray-200" />
        <span className="text-gray-300 ml-3">Custom</span>
      </button>
      {isOpen && (
        <div className="text-gray-300 absolute bottom-4" ref={ref}>
          <SketchPicker
            color={color}
            onChangeComplete={(color) => setColor(color.hex)}
          />
        </div>
      )}
    </form>
  )
}

const ChatMessageItem = ({ message, removed }) => {
  const { user } = useContext(AuthContext);
  const isModerator = user?.roles?.admin || user?.roles?.moderator
  const [userData, setUserData] = useState(null)
  const functions = getFunctions();
  const removeMessage = httpsCallable(functions, 'removeMessage');
  const banUser = httpsCallable(functions, 'banUser');

  const handleRemove = async () => {
    try {
      await removeMessage({ id: message.id })
    } catch (error) {
      errorToast(error)
    }
  }

  const handleBan = async () => {
    try {
      await banUser({ id: message.sender.id })
    } catch (error) {
      errorToast(error)
    }
  }

  return (
    removed ? (
      <p className="bg-gray-800 px-4 py-2.5 rounded-lg text-gray-300">This message has been removed.</p>
    ) : (
      <div className="px-4 py-2.5 flex rounded-lg relative group items-start">
        {isModerator && (
          <Menu as="div" className="absolute z-50 inset-0 invisible opacity-0 group-hover:visible group-hover:opacity-100">
            <div className="absolute inset-0 bg-gray-900 bg-opacity-70 rounded-md"></div>
            <div className="flex justify-end absolute left-2 top-2">
              <Menu.Button className="inline-flex p-1 rounded-full justify-center w-full text-sm font-medium bg-purple-600 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                <DotsVerticalIcon className="w-4" />
              </Menu.Button>
            </div>
            <Menu.Items className="absolute whitespace-nowrap left-0 mt-4 origin-top-right bg-gray-800 text-gray-300 font-medium divide-y divide-gray-100 rounded-md shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="text-sm py-1 z-50">
                <Menu.Item>
                  <button onClick={handleRemove} className="flex items-center space-x-2 px-2 py-1 hover:text-white text-300">
                    <MinusIcon className="w-4 transition duration-300" />
                    <span>Remove Message</span>
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button onClick={handleBan} className="flex items-center space-x-2 px-2 py-1 hover:text-white text-300">
                    <BanIcon className="w-4 transition duration-300" />
                    <span>Ban User</span>
                  </button>
                </Menu.Item>
              </div>
            </Menu.Items>
          </Menu>
        )}
        <div className="rounded-full p-1 border-[2px] mr-3.5 flex" style={{ borderColor: message?.color || "#fff" }}>
          <img src={message?.avatar} alt="" className="h-8 w-8 rounded-full object-cover flex" />
        </div>
        <div className="flex-1">
          <p className="font-medium text-gray-300 break-all">{message?.username}</p>
          <p className="break-all">{message?.message}</p>
        </div>
      </div>
    )
  )
}

const SetUsername = () => {
  return (
    <div className="bg-gray-800 p-2 grid gap-2">
      <div className="">
        <Button link to={modalRoutes.SET_USERNAME} className="py-2.5 px-4 w-full" modifier="secondary">Set Username</Button>
      </div>
      <p className="text-xs text-gray-300 text-center">You must set a username to join the chat</p>
    </div>
  )
}


const BannedUser = () => {
  return (
    <div className="bg-gray-800 px-2 py-4 grid gap-2">
      <p className="text-xs text-gray-300 text-center">You are currently banned from chatting.</p>
    </div>
  )
}

const RegisterUser = () => {
  return (
    <div className="bg-gray-800 p-2 grid gap-2">
      <div className="">
        <Button link to={modalRoutes.LOGIN} className="py-2.5 px-4 w-full" modifier="secondary">Login</Button>
      </div>
      <p className="text-xs text-gray-300 text-center">You must be logged in to join the chat</p>
    </div>
  )
}

const VerifyEmail = () => {
  return (
    <div className="bg-gray-800 p-2 grid gap-2">
      <div className="">
        <Button link to="/settings/general" className="py-2.5 px-4 w-full" modifier="secondary">Verify</Button>
      </div>
      <p className="text-xs text-gray-300 text-center">You must verify your email join the chat</p>
    </div>
  )
}